module.exports = __webpack_public_path__ + "img/level-curved-sec.9ea29eb4.svg";